import { type BoxProps, Box, Column, MotionPath } from "@hightouch/htui";
import { getTraceVariants } from "./utils";
import { SIZES } from "src/ui/box";

/**
 * Loader animation for line charts.
 * "roller coaster" effect.
 */
export const LineChartLoader = (props: BoxProps) => {
  const traceVariants = getTraceVariants();
  return (
    <Column
      align="center"
      justify="center"
      boxSize="100%"
      maxH="100%"
      {...props}
    >
      <Box
        as="svg"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="auto"
        fill="none"
        viewBox="0 0 736 135"
        maxW={SIZES.chartLoader}
        mx="auto"
      >
        <defs>
          <mask id="lineFadeMask">
            <rect width="100%" height="100%" fill="url(#lineFadeGradient)" />
          </mask>
          <linearGradient
            id="lineFadeGradient"
            x1="0%"
            y1="0%"
            x2="100%"
            y2="0%"
          >
            <stop offset="0%" stopColor="white" stopOpacity="0" />
            <stop offset="15%" stopColor="white" stopOpacity="1" />
            <stop offset="85%" stopColor="white" stopOpacity="1" />
            <stop offset="100%" stopColor="white" stopOpacity="0" />
          </linearGradient>
        </defs>

        <g mask="url(#lineFadeMask)">
          <Box
            as="path"
            stroke="gray.100"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m-7.41 133.464 121.475-40.213a11.997 11.997 0 0 1 3.54-.606l63.444-1.223a12 12 0 0 0 8.748-4.037l29.944-33.77a12 12 0 0 1 6.774-3.835L322.9 31.768a12.015 12.015 0 0 0 2.735-.859l62.129-28.058a12 12 0 0 1 11.21.705l81.922 50.208a12.018 12.018 0 0 0 2.951 1.3l34.131 9.827a12 12 0 0 0 8.596-.754l39.299-19.236a12.001 12.001 0 0 1 7.857-.94l88.388 19.468c2.088.46 4.261.353 6.294-.308L736 41.135"
          />
          <MotionPath
            stroke="gray.300"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="m-7.41 133.464 121.475-40.213a11.997 11.997 0 0 1 3.54-.606l63.444-1.223a12 12 0 0 0 8.748-4.037l29.944-33.77a12 12 0 0 1 6.774-3.835L322.9 31.768a12.015 12.015 0 0 0 2.735-.859l62.129-28.058a12 12 0 0 1 11.21.705l81.922 50.208a12.018 12.018 0 0 0 2.951 1.3l34.131 9.827a12 12 0 0 0 8.596-.754l39.299-19.236a12.001 12.001 0 0 1 7.857-.94l88.388 19.468c2.088.46 4.261.353 6.294-.308L736 41.135"
            variants={traceVariants}
            initial="initial"
            animate="animate"
          />
        </g>
      </Box>
    </Column>
  );
};
